/** Settings opens outside the dock; saved Settings panels remain readable. */
const listeners = new Set<() => void>();

export function openSettingsDialog(): void {
  for (const listener of listeners) listener();
}

export function onOpenSettingsDialog(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
